import {
  ALERT_FLAG,
  CARE_PLANNING_INITIAL_ASSESSMENT_FLAG,
  CARE_PLANNING_REVIEW_REPORTS_FLAG,
  CARE_PLANNING_RISK_ASSESSMENT_FLAG,
  CARE_PLANNING_SUPPORT_PLAN_FLAG,
  FAMILY_ADMIN_INTERFACE_FLAG,
  SERVICE_USER_ADMIN_NOTES_FLAG,
  STAFF_ADMIN_NOTES_FLAG,
  STAFF_INCOMPATIBILITY_MANAGEMENT_FLAG,
  FINANCE_INVOICES_FLAG,
  LINKED_VISIT_AUDIT_FLAG,
  TASK_MANAGEMENT_TEMPLATES_FLAG,
} from "@/config/releaseFlags";
import { ACCESS_LEVEL } from "@/utils/constants";

export type OptionsType = {
  id: string;
  title: string;
  path: string;
  className?: string;
  shouldShow?: boolean;
  child?: OptionsType[];
  authority?: ACCESS_LEVEL[];
  featureFlagKey?: string;
  subscriptionPath?: string;
};
export const OPTIONS: OptionsType[] = [
  {
    id: "staff",
    title: "Staff",
    path: "/staff",
    shouldShow: true,
    child: [
      {
        id: "staff-members",
        title: "Profile",
        path: "/staff-members",
        shouldShow: true,
        authority: [ACCESS_LEVEL.ADMINISTRATOR],
      },
      {
        id: "training-records",
        title: "Training records",
        path: "/training-records",
        shouldShow: true,
        authority: [ACCESS_LEVEL.ADMINISTRATOR],
      },
      {
        id: "documents",
        title: "Documents",
        path: "/documents",
        shouldShow: true,
        authority: [ACCESS_LEVEL.ADMINISTRATOR],
      },
      {
        id: "staff-admin-notes",
        title: "Admin notes",
        path: "/admin-notes",
        shouldShow: true,
        authority: [ACCESS_LEVEL.ADMINISTRATOR],
        featureFlagKey: STAFF_ADMIN_NOTES_FLAG,
      },
    ],
  },

  {
    id: "service-user",
    title: "Service Users",
    path: "/service",
    shouldShow: true,
    child: [
      {
        id: "profile",
        title: "Profile",
        path: "/service-user",
      },
      {
        id: "daily-notes",
        title: "Daily notes",
        path: "/daily-note",
      },
      {
        id: "about-me",
        title: "About me",
        path: "/about-me",
      },
      {
        id: "document",
        title: "Documents",
        path: "/document",
      },
      {
        id: "medication",
        title: "Medication",
        path: "/medication",
      },
      {
        id: "calender",
        title: "Calender",
        path: "/calender",
      },

      {
        id: "body-map",
        title: "Body map",
        path: "/body-map",
      },
      {
        id: "charts",
        title: "Charts",
        path: "/charts",
      },
      {
        id: "roster-dashboard",
        title: "Schedule visit",
        path: "/schedule-visit",
      },
      /*{
        id: "visit-audit",
        title: "Visit audit",
        path: "/schedule-visit/audit",
        featureFlagKey: LINKED_VISIT_AUDIT_FLAG,
      },*/
      {
        id: "admin-notes",
        title: "Admin notes",
        path: "/admin-notes",
        authority: [ACCESS_LEVEL.ADMINISTRATOR],
        featureFlagKey: SERVICE_USER_ADMIN_NOTES_FLAG,
      },
      {
        id: "family-access",
        title: "Family App",
        path: "/family-app",
        authority: [ACCESS_LEVEL.ADMINISTRATOR],
        featureFlagKey: FAMILY_ADMIN_INTERFACE_FLAG,
        subscriptionPath: "/service/family-access",
      },
      {
        id: "incompatibility",
        title: "Incompatibilities",
        path: "/incompatibility",
        featureFlagKey: STAFF_INCOMPATIBILITY_MANAGEMENT_FLAG,
      },
      {
        id: "care-planning",
        title: "Care Planning",
        path: "/care-planning",
        // className: "same-font-as-other-items",
        shouldShow: true,
        child: [
          {
            id: "initial-assessment",
            title: "Initial Needs Assessment",
            path: "/initial-assessment",
            featureFlagKey: CARE_PLANNING_INITIAL_ASSESSMENT_FLAG,
          },
          {
            id: "support-plan",
            title: "Support Plan",
            path: "/support-plan",
            featureFlagKey: CARE_PLANNING_SUPPORT_PLAN_FLAG,
          },
          {
            id: "risk-assessments",
            title: "Risk Assessments",
            path: "/risk-assessments",
            featureFlagKey: CARE_PLANNING_RISK_ASSESSMENT_FLAG,
          },
        ],
      },

      // {
      //   id: "risk-assessments",
      //   title: "Risk assessments",
      //   path: "/risk-assessments",
      // },
    ],
  },

  {
    id: "Daily note ",
    title: "Daily notes ",
    path: "/dailyNote",
    shouldShow: true,
    child: [
      // {
      //   id: "daily-note",
      //   title: "Daily Notes",
      //   path: "/daily-note",
      // },
      // {
      //   id: "add-note",
      //   title: "Add Notes",
      //   path: "/add-note",
      // },
    ],
  },
  {
    id: "task",
    title: "Task management",
    path: "/tasks-management",
    shouldShow: true,
    child: [
      {
        id: "to-do",
        title: "Task status",
        path: "/to-do",
      },
      {
        id: "all-tasks",
        title: "All tasks",
        path: "/all-tasks",
      },
      {
        id: "task-templates",
        title: "Templates",
        path: "/templates",
        authority: [ACCESS_LEVEL.ADMINISTRATOR, ACCESS_LEVEL.SENIOR_USER],
        featureFlagKey: TASK_MANAGEMENT_TEMPLATES_FLAG,
        subscriptionPath: "/tasks-management",
      },
    ],
  },
  {
    id: "roster",
    title: "Roster",
    path: "/roster",
    shouldShow: true,
    child: [],
  },
  {
    id: "handover",
    title: "Handovers",
    path: "/handover",
    shouldShow: true,
    child: [
      {
        id: "handover",
        title: "Handovers",
        path: "/",
      },
      {
        id: "handover-history",
        title: "History",
        path: "/history",
      },
    ],
  },
  {
    id: "report",
    title: "Reports",
    path: "/reports",
    shouldShow: true,
    child: [],
    featureFlagKey: CARE_PLANNING_REVIEW_REPORTS_FLAG,
  },
  {
    id: "document",
    title: "Documents",
    path: "/document",
    shouldShow: true,
    child: [],
  },
  {
    id: "finance",
    title: "Finance",
    path: "/finance",
    shouldShow: true,
    featureFlagKey: FINANCE_INVOICES_FLAG,
    child: [],
  },
  {
    id: "1",
    title: "",
    path: "/Zones",
    shouldShow: false,
    child: [
      {
        id: "zone",
        title: "Zones",
        path: "/zone",
      },

      {
        id: "unallocated",
        title: " Unallocated Service Users",
        path: "/unallocated",
      },
    ],
  },
  {
    id: "profile",
    title: "",
    path: "/profile",
    shouldShow: false,
    child: [
      {
        id: "my-profile",
        title: "My Profile",
        path: "/",
      },

      {
        id: "terms",
        title: " Terms",
        path: "/terms",
      },
    ],
  },
  {
    id: "alert",
    title: "Alerts",
    path: "/alert",
    shouldShow: true,
    child: [],
    featureFlagKey: ALERT_FLAG,
  },
];
